export const styles = (theme) => ({
    header: {
        background: theme.palette.primary.main,
        color: theme.palette.text.white,
        padding: '20px 40px'
    },
    content: {
        paddingTop: '10px'
    },
    actions: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: '0',
        padding: '10px 20px'
    },
    subTitle: {
        color: theme.palette.text.subTitle
    },
    formContainer: {
        padding: '0 20px'
    },
    activePeriodContainer: {
        marginTop: 20
    },
    optionsContainer: {
        marginTop: 20
    },
    helperText: {
        marginTop: '-1px'
    },
    specificOrgsContainer: {
        maxHeight: 300,
        overflow: 'auto'
    }
});
